import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ImgUp",
  "use": "icon-ImgUp-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ImgUp\"><path d=\"M929.792 874.496L766.976 711.68c55.808-67.072 87.552-152.064 87.552-239.104 0-206.336-167.936-373.76-373.76-373.76s-373.76 167.424-373.76 372.736c0 206.336 167.936 373.248 373.248 373.248 84.992 0 167.936-29.696 234.496-82.944l163.84 163.84c7.168 7.168 16.384 10.752 25.6 10.752 9.216 0 18.944-3.072 25.6-10.752 14.336-13.824 14.336-36.864 0-51.2z m-299.52-370.688h-117.248v117.248c-0.512 16.384-14.848 29.696-32.256 29.696s-31.744-13.312-31.744-29.696V503.808h-117.76c-16.384 0-29.696-14.336-29.696-32.256 0-17.408 12.8-32.256 29.696-32.256h117.76V322.56c0-16.384 14.336-29.696 32.256-29.696 17.408 0 31.744 13.312 31.744 29.696v116.736h117.248c16.384 0 29.696 14.336 29.696 32.256s-13.312 32.256-29.696 32.256z\" fill=\"#4b5563\" p-id=\"4181\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ImgUp.svg
// module id = sRBo
// module chunks = 55